import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box, Divider } from '@mui/material';
import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

interface WidgetTooltipProps extends TooltipProps<ValueType, NameType> {
  children: React.ReactNode;
}

const WidgetTooltip = ({ active, payload, children }: WidgetTooltipProps) => {
  if (active && payload?.length) {
    return (
      <Box
        sx={{
          backgroundColor: 'var(--color-surface-immutable-darkGrey)',
          border: `1px solid var(--color-border-base-subdued)`,
          borderRadius: '12px',
          padding: '8px 16px',
          minWidth: '250px',
          fontSize: '13px',
          color: 'var(--color-content-immutable-white)',
          ...flex.col,
          gap: 1,
        }}>
        {children}
      </Box>
    );
  }

  return null;
};

export default WidgetTooltip;

export const TooltipDivider = () => <Divider sx={{ borderColor: 'var(--color-content-immutable-grey)' }} />;
